/** The Screen Wake Lock subset the in-person page uses; absent on browsers without the API. */
export type ScreenWakeLock = { release: () => Promise<void> };
type WakeLockNavigator = { wakeLock?: { request: (type: 'screen') => Promise<ScreenWakeLock> } };

export const KEEP_SCREEN_ON_TEXT = 'Keep this screen on while recording';

/**
 * Holds the screen on while recording (design Decision 11). Resolves undefined where the API is
 * missing or the lock is refused, so the page shows "Keep this screen on while recording".
 */
export async function requestScreenWakeLock(nav: WakeLockNavigator | undefined): Promise<ScreenWakeLock | undefined> {
  try {
    return (await nav?.wakeLock?.request('screen')) ?? undefined;
  } catch {
    return undefined;
  }
}
